<article>
  <main>
    @if (notifications?.length) {
      <section>
        <table class="table table-sm">
          <thead>
            <tr>
              <th class="text-left">Contact</th>
            </tr>
          </thead>
          <tbody>
            @for (user of notifications; track $index) {
              <tr>
                <td>{{ user.value }}</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    } @else if (groupings?.length) {
      @if (groupingsAvailable()) {
        <section>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Group</th>
                <th>Members</th>
              </tr>
            </thead>
            <tbody>
              @for (group of groupings; track $index) {
                <tr>
                  <td>{{ group.title }}</td>
                  <td>
                    @for (user of groupingsAvailable()[group.id]?.users; track user.id) {
                      <app-chip size="small" [label]="user.name" />
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </section>
      } @else {
        <i class="mdi mdi-spin-x2 mdi-loading"></i>
      }
    } @else {
      <app-info-panel>No notifications when in alarm</app-info-panel>
    }
  </main>
</article>
